import { render, staticRenderFns } from "./TipoConceptoCombobox.vue?vue&type=template&id=289015b0&scoped=true&"
import script from "./TipoConceptoCombobox.vue?vue&type=script&lang=js&"
export * from "./TipoConceptoCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289015b0",
  null
  
)

export default component.exports